import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Badge, Descriptions } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import { ModalWrapper } from 'components';
import { Modal } from 'types/modal';
import { systemActions } from 'store/system/slices';
import systemSelectors from 'store/system/selectors';
import { stringifyUrlParams, useUrlParams } from 'hooks/use-url-params';
import { DATE_FORMAT } from '../../../app-constants/date';
import { ConnectorData } from '../../../store/system/types';
import { StyledContent, StyledEditLink } from './styles';
import { UpdateContent } from './modal';
import { ConnectorBase } from '../types';

interface ConnectorSummaryProps {
  state: ConnectorData | null;
  onSubmitEditConnector: (data: ConnectorBase) => void;
}

export const ConnectorSummary: React.FC<ConnectorSummaryProps> = ({ state, onSubmitEditConnector }) => {
  const { t } = useTranslation();
  const {
    location: { pathname, search },
    goBack,
  } = useHistory();
  const { queryUrlParams } = useUrlParams({});
  return (
    <StyledContent>
      <StyledEditLink>
        {state && (
          <Link
            to={{
              pathname,
              search: stringifyUrlParams({ ...queryUrlParams, modal: Modal.EDIT_CONNECTOR, connection: state?.id }),
            }}
          >
            <EditOutlined style={{ fontSize: 20 }} />
          </Link>
        )}
      </StyledEditLink>
      <Descriptions title={state?.name} layout="vertical" bordered>
        <Descriptions.Item label="Версія">1.0</Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.type')}>{state?.type}</Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.definition')}>{state?.definition}</Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.timestamp')} span={2}>
          {dayjs(state?.timestamp).format(DATE_FORMAT.TABLE_FORMAT)}
        </Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.enabled')} span={2}>
          {dayjs(state?.timestamp).format(DATE_FORMAT.TABLE_FORMAT)}
        </Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.status')}>
          <Badge status="error" text="Офлайн" />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.rate')}>{state?.rate}</Descriptions.Item>
        <Descriptions.Item label={t('system.connectors.error_rate')}>{state?.rate}</Descriptions.Item>
      </Descriptions>
      <ModalWrapper
        isVisible={search.includes(`modal=${Modal.EDIT_CONNECTOR}`)}
        onClose={goBack}
        title={t('group.modal.title.edit')}
        width={900}
        destroyOnClose
      >
        <UpdateContent state={state} onSubmitForm={onSubmitEditConnector} />
      </ModalWrapper>
    </StyledContent>
  );
};
